import store from "data/store";
import {
  createChannel,
  formatChatData,
  loadArchivedHistoryChats,
  loadHistoryChats,
  loadHistoryWorkSessionChats,
  loadTrialHistoryChats,
} from "./utils";
import NavigationService from "services/navigation";
import { notification } from "antd";
import newChatAudioFile from "assets/audio/chat.mp3";
import disconnectChannelAudioFile from "assets/audio/dial-tone-5s.mp3";

class ChatsService {
  constructor() {
    this.chatConnectAudio = new Audio(newChatAudioFile);
    this.disconnectChannelAudio = new Audio(disconnectChannelAudioFile);
  }

  init = () => {
    this.historyChatsChannel = createChannel(
      "RealtimeChat::HistoryChatsChannel",
      {
        received: this._handleHistoryChatsChannelReceived,
      }
    );

    this.connectChannel = createChannel("RealtimeChat::ConnectChannel", {
      received: this._handleChannelReceived,
      disconnected: this.#disconnect,
      connected: this.#connected,
    });
  };

  #disconnect = () => {
    store.resetChats();
    notification.error({ message: "Connection with the server has been lost" });
    this.disconnectChannelAudio?.play();
  };

  #connected = () => {
    loadHistoryChats().then(store.historyChats.set);
    loadArchivedHistoryChats().then(store.archivedHistoryChats.set);
    loadTrialHistoryChats().then(store.trialChats.set);
    loadHistoryWorkSessionChats().then(store.workSessionChats.set);
    notification.success({ message: "Connected to the server" });
  };

  _handleHistoryChatsChannelReceived = (data) => {
    const { action, message } = data;
    if (action === "new_message") {
      const chat = store.byHistoryChatId(message.roomId);
      if (chat) chat.addNewMessage(message);
    }
  };

  _handleChannelReceived = (data) => {
    const { action, message } = data;
    if (action === "add_chat_room") this._activeChat(message);
    if (action === "remove_chat_room") this._inactivateChat(message);
    if (action === "set_chat_rooms") {
      message.forEach((chat) => this._activeChat(chat));
    }
  };

  _activeChat = (chatData) => {
    if (!store.chats.hasChat(chatData.id))
      store.chats.add(formatChatData(chatData));
    this.chatConnectAudio?.play();
    const chat = store.chats.byId(chatData.id);
    console.log("chat", chat);
    chat.start();
    store.chats.sortChatsByOnline();
  };

  _inactivateChat = (chatId) => {
    const chat = store.chats.byId(chatId);
    if (chat) chat.stop();
  };

  selectChat = (chatId) => {
    store.selectChat(chatId);
    NavigationService.navigate("/active_chat");
  };

  dispose = () => {
    store.resetChats();
    this.connectChannel.dispose();
    this.historyChatsChannel.dispose();
  };
}

export default new ChatsService();
